document.addEventListener("DOMContentLoaded", function() {
    
    // Product media grid
    const allSlides = document.querySelectorAll('.custom-grid__product-media');

    if(allSlides.length === 1) {
        allSlides[0].classList.add('only-one-child');
    }

    if (allSlides.length % 2 === 0) {
        allSlides[allSlides.length - 1].classList.add('even');
    } else {
        allSlides[allSlides.length - 1].classList.add('odd');
    }

    // Complete your look carousel
    const sliderItems = document.querySelectorAll('.getSlides');
    const completeYourLookAccordion = document.querySelectorAll('[data-complete-your-look="true"]');

    // For get complete_your_look slider length.
    if (sliderItems.length === 1) {
        sliderItems[0].classList.add('uniqSlide');
        sliderItems[0].parentElement.classList.add('uniqSlideAlignment');
    }

    // For hide complete_your_look slider if length equal 0.
    if (sliderItems.length === 0) {
        const element = completeYourLookAccordion[0].parentElement.parentElement;
        element.classList.add('hidden');
        element.parentElement.classList.add('removeBorderBottom');
    }

    // Change button add to cart if product has uniq size.
    const selectorBoxes = document.querySelectorAll('.product-form__variant-selector-boxes')[0];
    const chooseSizeBtn = document.querySelectorAll('.select-size')[0];
    const addToCartBtn = document.querySelectorAll('.uniq-size')[0];
    const selectorBox = selectorBoxes.children[0].getAttribute('data-option');
    if(selectorBox == 'UNIC') {
        chooseSizeBtn.classList.add('hidden');
        addToCartBtn.classList.remove('hidden')
        const checkoutBtn = document.querySelectorAll(`[data-trigger=product-form__radios-item-trigger-UNIC]`);
        checkoutBtn[0].click();
    }

    
});

function getVariant(event) {
    const selectors = event.target.closest('.product-form__variant-selector-boxes ').querySelectorAll('.product-form__variant-selector-box');
    selectors.forEach((selector) => {
        selector.classList.remove('underline_active');
    })
    const selectedSize = event.target.getAttribute('data-option');
    event.target.classList.remove('underline_active');
    const test = document.querySelectorAll(`[data-trigger=product-form__radios-item-trigger-${selectedSize}]`);
    test[0].click();
    event.target.classList.add('underline_active');
}

function scrollToRecommendations() {
    const productRecommendationsSection = document.getElementById('product-recommendation');
    const targetOffset = productRecommendationsSection.getBoundingClientRect().top + window.scrollY;
    const adjustedScrollY = targetOffset - 100;

    window.scrollTo({
        top: adjustedScrollY,
        behavior: 'smooth'
    });

}